export const useGetHoursOfDay = () => [...Array.from({ length: 24 }).keys()];
